import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import EnterPhoneNumber from "../login/EnterPhoneNumber";
import { zodResolver } from "@hookform/resolvers/zod";
import customZ from "../../utils/setZodCustomMessages";
import { mobileNumberSchema } from "../../utils/customSchemas";
import EnterOtp from "../login/EnterOtp";
import NewPasswordSetter from "../login/NewPasswordSetter";

const ForgetPasswordStepsModal = ({
  handleScroll,
  modalContentRef,
  forgetPasswordModal,
  setOpenPhoneNumber,
  closeModal,
  onClose,
  navigateHere,
  goToMainLoginModal,
}: any) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [enterPhoneNumber, setEnterPhoneNumber] = useState<boolean>(true);
  const [enterOtp, setEnterOtp] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState<boolean>(false);
  const [otp_ticket, setOtp_ticket] = useState<string | null>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  interface ForgetPasswordSchema {
    forget_phone_number: string;
    forget_otpCodeNumber: string;
  }

  const phoneSchema = customZ.object({
    forget_phone_number: mobileNumberSchema,
  });

  const {
    handleSubmit,
    control,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm<ForgetPasswordSchema>({
    resolver: (data, context, options) => {
      return zodResolver(phoneSchema)(data, context, options);
    },
  });

  const goToPhoneNumber = () => {
    setEnterOtp(false);
    setEnterPhoneNumber(true);
  };

  const goToOTP = () => {
    setEnterOtp(true);
    setEnterPhoneNumber(false);
  };

  const setNewPasswordHandeller = () => {
    setEnterOtp(false);
    setEnterPhoneNumber(false);
    setNewPassword(true);
  };

  const closeModalNotSetPassword = () => {
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
    onClose();
    const body = document.querySelector("body");
    if (body) {
      body.classList.remove("overflow-hidden");
    }
  };

  return (
    <>
      <div className="">
        {enterPhoneNumber ? (
          <EnterPhoneNumber
            isForgetPassword
            onEnterPhone={goToOTP}
            handleSubmit={handleSubmit}
            control={control}
            errors={errors}
            goToOTP={goToOTP}
            closeModal={closeModal}
            otp_ticket={otp_ticket}
            setOtp_ticket={setOtp_ticket}
          />
        ) : enterOtp ? (
          <EnterOtp
            isForgetPassword
            handleSubmit={handleSubmit}
            control={control}
            errors={errors}
            getValues={getValues}
            watch={watch}
            otpClose={goToPhoneNumber}
            otp_ticket={otp_ticket}
            navigateHere={navigateHere}
            closeModal={closeModal}
            onOpemRules={setNewPasswordHandeller}
            setOtp_ticket={setOtp_ticket}
            setValue={setValue}
          />
        ) : (
          newPassword && (
            <>
              <NewPasswordSetter
                isForgetPassword
                goToMainLoginModal={goToMainLoginModal}
                closeModalNotSetPassword={closeModalNotSetPassword}
                closeModal={closeModal}
                getValues={getValues}
                otp_ticket={otp_ticket}
                navigateHere={navigateHere}
              />
            </>
          )
        )}
      </div>
    </>
  );
};

export default ForgetPasswordStepsModal;
